import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const CheckoutCancel = () => {
  return (
    <div className="min-h-screen pt-24 px-4 bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center max-w-md">
        <XCircle className="w-16 h-16 text-[#E07A5F] mx-auto mb-6" />
        <h1 className="text-3xl font-bold font-['Space_Grotesk'] text-[#F4F1DE] mb-4">
          Checkout Cancelled
        </h1>
        <p className="text-[#F4F1DE]/60 mb-8">
          No worries! Your cart items are still saved. Return whenever you're ready to complete your order.
        </p>
        <div className="space-y-4">
          <Link to="/cart" data-testid="cancel-cart-link">
            <Button className="w-full bg-[#E07A5F] hover:bg-[#D06A4F] text-white">
              <ArrowLeft className="mr-2 w-5 h-5" />
              Return to Cart
            </Button>
          </Link>
          <Link to="/configurator">
            <Button variant="outline" className="w-full border-white/20 text-[#F4F1DE]/80">
              Continue Building
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
